const NUM_GTE = 1
const NUM_GT = 2

/**
 * 满足该档位条件的最小整数「累计有效人数」
 * - >= n  -> n
 * - > n   -> n + 1
 */
export function getTierEffectiveMin(t) {
  const need = Number(t?.need_share_one_num)
  const n = Number.isFinite(need) ? need : 0
  const op = Number(t?.num_interval_type) === NUM_GT ? NUM_GT : NUM_GTE
  return op === NUM_GT ? n + 1 : n
}

/** 按邀请有效人数门槛从低到高排序（返回新数组） */
export function sortAgentBoxTiersByInviteAsc(tiers) {
  if (!Array.isArray(tiers)) return []
  return [...tiers].sort((a, b) => getTierEffectiveMin(a) - getTierEffectiveMin(b))
}
